import {
  LOGIN,
  LOGOUT,
  USER_DETAILS,
  HANDLEDRAWER,
  CLEAR_LOGIN,
  SET_ADMIN_ID,
  ADMITCARD_DETAILS
} from "./constant";
import UNIVERSAL from "../config/config";
import { setLoader, unsetLoader } from "../common/loader/action";
import { set_snack_bar } from "../common/snackbar/action";

export function super_login(aadharNo, dob) {
  return async (dispatch) => {
    dispatch(setLoader());
    try {
      const response = await fetch(UNIVERSAL.BASEURL + "login", {
        method: "POST",
        headers: { Accept: "application/json", "Content-Type": "application/json" },
        body: JSON.stringify({ aadhar: aadharNo, dob: dob }),
      });
      const responseJson = await response.json();
      if (responseJson.status) {
        dispatch(setAdminLogin(responseJson.result.user));
        dispatch({ type: USER_DETAILS, payload: responseJson.result.user });
        dispatch({ type: ADMITCARD_DETAILS, payload: responseJson.result.admitCard });
        dispatch(setAdminId(responseJson.result.user._id));
        dispatch(set_snack_bar(responseJson.status, "Login Successfully"));
      } else {
        dispatch(set_snack_bar(responseJson.status, "Invalid Aadhaar or Date of Birth"));
      }
    } catch (error) {
      console.error(error);
      dispatch(set_snack_bar(false, "Network error. Please try again."));
    } finally {
      dispatch(unsetLoader());
    }
  };
}

export function clear_login() {
  return { type: CLEAR_LOGIN };
}

export function setAdminId(payload) {
  return { type: SET_ADMIN_ID, payload: payload };
}

export function setAdminLogin(payload) {
  localStorage.setItem("user_id", payload._id);
  localStorage.setItem("type", payload.type);
  return { type: LOGIN, payload: payload };
}

export function handleDrawerToggle(mobileOpen) {
  mobileOpen = !mobileOpen;
  return { type: HANDLEDRAWER, payload: mobileOpen };
}

export function onLogout() {
  localStorage.removeItem("user_id");
  localStorage.removeItem("type");
  return { type: LOGOUT };
}

export function register_user(name, aadhar, dob, mobile) {
  return async (dispatch) => {
    dispatch(setLoader());
    try {
      const response = await fetch(UNIVERSAL.BASEURL + "add_user", {
        method: "POST",
        headers: { Accept: "application/json", "Content-Type": "application/json" },
        body: JSON.stringify({ name, aadhar, dob, mobile }),
      });
      const responseJson = await response.json();
      if (responseJson.status) {
        dispatch(set_snack_bar(true, "Registration Successful! Logging you in..."));
        // ── AUTO LOGIN after registration ──
        const loginRes = await fetch(UNIVERSAL.BASEURL + "login", {
          method: "POST",
          headers: { Accept: "application/json", "Content-Type": "application/json" },
          body: JSON.stringify({ aadhar: aadhar, dob: dob }),
        });
        const loginJson = await loginRes.json();
        if (loginJson.status) {
          dispatch(setAdminLogin(loginJson.result.user));
          dispatch({ type: USER_DETAILS, payload: loginJson.result.user });
          dispatch({ type: ADMITCARD_DETAILS, payload: loginJson.result.admitCard });
          dispatch(setAdminId(loginJson.result.user._id));
        }
      } else {
        dispatch(set_snack_bar(false, responseJson.message));
      }
    } catch (error) {
      console.error(error);
      dispatch(set_snack_bar(false, "Network error. Please try again."));
    } finally {
      dispatch(unsetLoader());
    }
  };
}